module.exports = __webpack_public_path__ + "static/media/magneuro31.134416b8.png";